/** @format */
import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import React, { FunctionComponent } from 'react';

/* eslint-disable boundaries/element-types -- Disabled as this is a NextJS wrapper around our Link component which should be coming from Feather */
import { Link, LinkProps } from '@toucan/client/shared/components/link';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type WrappedLinkProps = LinkProps & NextLinkProps;

export const WrappedLink: FunctionComponent<WrappedLinkProps> = ({
    as,
    href,
    passHref,
    children,
    ...otherProps
}: WrappedLinkProps) => {
    return (
        <NextLink
            prefetch={false}
            href={href}
            as={as}
            passHref={passHref}
            legacyBehavior
        >
            <Link href={as?.toString()} {...otherProps}>
                {children}
            </Link>
        </NextLink>
    );
};
